<template>
  <div class="animated fadeIn">
    <div class="row" >
      <div class="col-sm-12">
        <b-card body-class="bg-gray-100 ">
          <div slot="header"  ref="div-botoes">
            <i class='fa fa-align-justify'></i><strong>  PRODUÇÃO ORDEM DE ABATE  </strong> <small>Identificação Básicas</small>
            <div class="card-alinha" ref="linha-botoes">
              <b-button variant="outline-info"  type="button" @click.stop.prevent="onVoltarPrincipal()" > 
                  <i class="fa fa-arrow-left"></i>  Voltar
              </b-button>
              
              <b-button v-if="(registro.STATUS == '4' || registro.STATUS == '5' || registro.STATUS == '6') " variant="warning"  type="button" @click.stop.prevent="onPausar()" > 
                  <i class="fa fa-pause-circle-o"></i>  Pausar Pesagem
              </b-button>
              <b-button  v-if="(registro.STATUS == '7')" variant="info"  type="button" @click.stop.prevent="onContinuar()" > 
                  <i class="fa fa-pause-circle-o"></i>  Continuar
              </b-button>
            </div>
          </div>
          <b-row>
            <!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Código ID">
                <b-form-input type="text" id="edID" :disabled="true" placeholder="Código Automático" v-model="registro.ID"></b-form-input>
              </b-form-fieldset>
            </div>
            
            <div class="col-sm-2">
              <b-form-fieldset label="Numero Lote">
                <b-form-input type="text" id="edLOTE" :disabled="true" placeholder="Número do Lote" v-model="registro.LOTE"></b-form-input>
              </b-form-fieldset>
            </div>
            
            <!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Data Emissão">
                <b-form-input  type="date" id="edDT_LANCAMENTO" :disabled="true" v-model="registro.DT_LANCAMENTO" placeholder="" > </b-form-input>
              </b-form-fieldset>
            </div>  
            <!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Hora Início">
                <b-form-input  type="time" id="edDT_LANCAMENTO" :disabled="true" v-model="registro.HORA_SAI" placeholder="" > </b-form-input>
              </b-form-fieldset>
            </div>  
            <!--/.col-->
            <div class="col-sm-4">
              <b-form-fieldset label="Situação">
                <b-form-input  type="text" id="edSituacao" :disabled="true" v-model="traduzStatus" placeholder="" > </b-form-input>
              </b-form-fieldset>
            </div>  
          </b-row>  
          <b-row>
            <!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Data do Lote">
                <b-form-input  type="date" id="edDT_LOTE"  v-model="registro.DT_LOTE" :disabled="true" placeholder="" > </b-form-input>
              </b-form-fieldset>
            </div>  
            <!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="Hora da Entrada">
                <b-form-input  type="time" id="edHORA_ENT"  v-model="registro.HORA_ENT" :disabled="true" placeholder="" > </b-form-input>
              </b-form-fieldset>
            </div>  
            <!--/.col-->
            <div class="col-sm-2">
              <b-form-fieldset label="GTA">
                <b-form-input type="text" id="edGTA"  placeholder="Número do GTA" v-model="registro.GTA" :disabled="true"></b-form-input>
              </b-form-fieldset>
            </div>
            <!--/.col-->
            <b-col sm="3">
              <b-form-fieldset label="Tipo de Processo">
                <b-form-select  :plain="true" 
                                id="comboTipoProcesso"
                                :disabled="true"
                                v-model="registro.OP_TIPO_SERVICO"
                                :options="tipoServico">
                  </b-form-select>
              </b-form-fieldset>
            </b-col>
            <!--/.col-->
            <b-col sm="3">
              <centro-estoque-pesquisa 
                  @retornaId="registro.CENTRO_ESTOQUE_ORIGEM_ID = $event"
                  :idInicial="registro.CENTRO_ESTOQUE_ORIGEM_ID"
                  :desabilitarInput="true"
                  idModal="modalCentroEstoqueOrigem"
                  label="Estoque de Origem"
                  id="edCENTRO_ESTOQUE_ORIGEM_ID"
                  place="Informe Estque de Origem"
                  labelBotao="">
              </centro-estoque-pesquisa>
            </b-col>
          </b-row>  
          <b-row class="row">
            <b-col sm="4">
              <cliente-pesquisa 
                  @retornaId="registro.CLIENTE_ID = $event"
                  :idInicial="registro.CLIENTE_ID"
                  :desabilitarInput="true"
                  id="edCLIENTE_ID"
                  idModal="modalCliente"
                  label="Cliente"
                  place="Informe o Fornecedor"
                  labelBotao="">
              </cliente-pesquisa>
            </b-col>
            <b-col sm="4">
              <cliente-pesquisa 
                @retornaId="registro.MARCHANT_ID = $event"
                :idInicial="registro.MARCHANT_ID"
                :desabilitarInput="true"
                idModal="modalMarchant"
                label="Marchante"
                id="edMARCHANT_ID"
                place="Informe o Marchant"
                labelBotao="">
              </cliente-pesquisa>
            </b-col>
            <b-col sm="4">
              <cliente-pesquisa 
                  @retornaId="registro.FAZENDA_ID = $event"
                  :idInicial="registro.FAZENDA_ID"
                  :desabilitarInput="true"
                  idModal="modalFazenda"
                  label="Fazenda"
                  id="edFAZENDA_ID"
                  place="Informe a Fazenda"
                  labelBotao="">
              </cliente-pesquisa>
            </b-col>
          </b-row> 
           
        </b-card>
        <b-row>
          <b-col sm="12">
            <b-card body-class="bg-gray-100"  >
              <div slot="header">
                <i class='fa fa-align-justify'></i> <strong>Resumo</strong>
              </div>
              <b-row>
                <b-col sm="2">
                  <b-form-fieldset label="Animais Planejados">
                    <vue-autonumeric  v-model="rodape.edAnimais" 
                            :disabled="true"
                            :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  roundingMethod: 'U',
                                  minimumValue: '0'
                            }"
                            class="form-control text-right"  >
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Animais Abatidos">
                    <vue-autonumeric  v-model="rodape.edAbatidos" 
                            :disabled="true"
                            :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  roundingMethod: 'U',
                                  minimumValue: '0'
                            }"
                            class="form-control text-right"  >
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Animais Restantes">
                    <vue-autonumeric  v-model="rodape.edRestante" 
                            :disabled="true"
                            :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  roundingMethod: 'U'
                            }"
                            class="form-control text-right"  >
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Bandas Pesadas">
                    <vue-autonumeric  v-model="rodape.edBandasPesadas" 
                            :disabled="true"
                            :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  roundingMethod: 'U',
                                  minimumValue: '0'
                            }"
                            class="form-control text-right"  >
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Quilos Pesados">
                    <vue-autonumeric  v-model="rodape.edQuilosPesados" 
                            :disabled="true"
                            :options="{
                                  digitGroupSeparator: '.',
                                  decimalCharacter: ',',
                                  decimalCharacterAlternative: '.',
                                  roundingMethod: 'U',
                                  minimumValue: '0'
                            }"
                            class="form-control text-right"  >
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-card body-class="bg-gray-100"  >
              <div slot="header">
                <i class='fa fa-align-justify'></i> <strong>Pesagem</strong>
                <div v-if="registro.STATUS != '7'"  class="card-alinha">
                  <b-button v-if="botoes.boi == true " variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('boi')" > 
                    <i  class="fa fa-plus-square-o"></i> BOI
                  </b-button>
                  <b-button v-if="botoes.vaca == true" variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('vaca')" > 
                    <i  class="fa fa-plus-square-o"></i> VACA
                  </b-button>
                  <b-button v-if="botoes.novilha == true" variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('novilha')" > 
                    <i  class="fa fa-plus-square-o"></i> NOVILHA
                  </b-button>
                  <b-button v-if="botoes.touro == true" variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('touro')" > 
                    <i  class="fa fa-plus-square-o"></i> TOURO
                  </b-button>
                  <b-button v-if="botoes.capao == true" variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('capao')" > 
                    <i  class="fa fa-plus-square-o"></i> CAPAO
                  </b-button>
                  <b-button v-if="botoes.boiInteiro == true" variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('boiInteiro')" > 
                    <i  class="fa fa-plus-square-o"></i> BOI INT
                  </b-button>
                  <b-button v-if="botoes.bufaloMacho == true" variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('bufaloMacho')" > 
                    <i  class="fa fa-plus-square-o"></i> BU. MACHO
                  </b-button>
                  <b-button v-if="botoes.bufaloFemea == true" variant="primary"  type="button" @click.stop.prevent="onAbrirModalAnimal('bufaloFemea')" > 
                    <i  class="fa fa-plus-square-o"></i> BU. FEMEA
                  </b-button>
                  
                </div>

              </div>
              <b-row>
                <b-col sm="12">
                      <b-table striped hover :items="tabelaAnimais.items" :fields="tabelaAnimais.fields">
                        <template #cell(actions)="item">
                          <b-button  type="button" v-if="exibirBotaoExcluirItem(item.item) == true" @click="onDeleteAnimal(item.item)" size="sm" variant="danger" title="Remover Animal" v-b-tooltip.hover.left>
                            <i class="fa fa-close"></i>
                          </b-button>
                        </template>
                      </b-table>
                </b-col>

              </b-row>
            </b-card>
          </b-col>
         

        </b-row>  
        <b-row>
          <b-col sm="6">
            <b-card body-class="bg-gray-100 ">
              <div slot="header" >
                <i class='fa fa-align-justify'></i><strong>  RESUMO DO ABATE  </strong>
              </div>
              <b-row>
                <b-col sm="12">
                      <b-table striped hover :items="tabelaAbatidos.items" :fields="tabelaAbatidos.fields">
                        <template #cell(actions)="item">
                        </template>
                      </b-table>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col sm="6">
            <b-card body-class="bg-gray-100 ">
              <div slot="header" >
                <i class='fa fa-align-justify'></i><strong>  CLASSIFICAÇÃO  </strong>
              </div>
              <b-row>
                <b-col sm="12">
                      <b-table striped hover :items="tabelaResumoClassificacao.items" :fields="tabelaResumoClassificacao.fields">
                        <template #cell(actions)="item">
                        </template>
                      </b-table>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    
    <!--/.row-->
    <b-card :no-body="true" body-class="bg-gray-100 ">
          <div slot="header" >
            <i class='fa'></i>
            <div class="card-alinha">
              <b-button variant="outline-info"  type="button" @click.stop.prevent="onVoltarPrincipal()" > 
                  <i class="fa fa-arrow-left"></i>  Voltar
              </b-button>
            </div>
          </div>
    </b-card>
    <div>
        <!--  -----------------------------------------------------------------------------------
                                            MODAL CADASTAR ANIMAL 
              ----------------------------------------------------------------------------------- -->
          <b-modal ref="modal-animal" 
              id="modal-animal" 
              hide-header
              body-class="p-0"
              no-close-on-esc
              no-close-on-backdrop
              centered
              size="lg"
              @shown="focusModalAnimal()" 
              headerClass= "p-2 border-bottom-0" 
              title="Cadastrar Animal" >
            <b-card bg-variant="light">
                <div slot="header">
                    <i class='fa fa-align-justify'></i><strong>  ANIMAL</strong>
                </div>
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label class="caixa-cabecalho">Display</label>
                        <vue-autonumeric  v-model="modalAnimal.pesoDisplay" 
                                      ref="edBANDA1"
                                      :readonly="true"
                                      :options="{
                                            digitGroupSeparator: '.',
                                            decimalCharacter: ',',
                                            decimalCharacterAlternative: '.',
                                            roundingMethod: 'U',
                                            minimumValue: '0'
                                      }"
                                      :class="['form-control text-right caixa-display']">
                        </vue-autonumeric>
                    </b-form-group>
                  </b-col>  
                  <b-col sm="3">
                    <b-form-group>
                      <label class="caixa-cabecalho">Tara</label>
                        <vue-autonumeric  v-model="modalAnimal.tara" 
                                      ref="edBANDA1"
                                      :disabled="true"
                                      :options="{
                                            digitGroupSeparator: '.',
                                            decimalCharacter: ',',
                                            decimalCharacterAlternative: '.',
                                            roundingMethod: 'U',
                                            minimumValue: '0'
                                      }"
                                      :class="['form-control text-right caixa-tara']">
                        </vue-autonumeric>
                    </b-form-group>
                  </b-col>
                  <b-col sm="5">
                    <label class="caixa-cabecalho">Peso Bruto</label>
                    <b-input-group >
                      
                        <vue-autonumeric  v-model="modalAnimal.pesoBruto" 
                                      ref="edBANDA1"
                                      :disabled="true"
                                      :options="{
                                            digitGroupSeparator: '.',
                                            decimalCharacter: ',',
                                            decimalCharacterAlternative: '.',
                                            roundingMethod: 'U',
                                            minimumValue: '0'
                                      }"
                                      :class="['form-control text-right caixa-bruto']">
                        </vue-autonumeric>
                        <b-input-group-append>
                        <b-button :disabled="modalAnimal.pesou2 == true" variant="success" @click="onSelecionaPeso()">
                          <span><i  class="fa fa-check"></i></span>
                        </b-button>
                        
                        
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>

                </b-row>
                <hr>
                <b-row>
                  <b-col sm="12">
                    <animal-pesquisa 
                                      @retornaId="animal.PRODUTO_ID = $event"
                                      :idInicial="animal.PRODUTO_ID"
                                      :desabilitarInput="true"
                                      id="edPRODUTO_ID"
                                      ref="edPRODUTO_ID"
                                      idModal="modalAnimal"
                                      label="Animal"
                                      place="Informe Animal"
                                      labelBotao="">
                    </animal-pesquisa>
                  </b-col>
                </b-row>
                
                <b-row>
                  <!--/.col-->
                  <b-col sm="7">
                    <b-input-group  prepend="Banda 1 Kg" class="mt-3 font-maquina">
                      <vue-autonumeric  v-model="animal.BANDA1" 
                              ref="edBANDA1"
                              :readonly="true"
                              :options="{
                                    digitGroupSeparator: '.',
                                    decimalCharacter: ',',
                                    decimalCharacterAlternative: '.',
                                    roundingMethod: 'U',
                                    minimumValue: '0'
                              }"
                              :class="['form-control text-right caixa-banda ', {
                                                    'is-valid' : animal.BANDA1 && animal.BANDA1 > 0.00,
                                                    'is-invalid' : !animal.BANDA1 || animal.BANDA1 <= 0.00
                                                  }]">
                      </vue-autonumeric>
                      <b-input-group-append>   
                        <b-button  :disabled="modalAnimal.pesou1 == false ||  modalAnimal.pesou2 == true "  variant="danger" @click="onRemovePeso()">
                          Remover Peso
                        </b-button>
                        
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  </b-row>
                  <b-row>
                    <!--/.col-->
                    <b-col sm="7">
                      <b-input-group prepend="Banda 2 Kg" class="mt-3 font-maquina">
                        <vue-autonumeric  v-model="animal.BANDA2" 
                                ref="edBANDA2"
                                :readonly="true"
                                :options="{
                                      digitGroupSeparator: '.',
                                      decimalCharacter: ',',
                                      decimalCharacterAlternative: '.',
                                      roundingMethod: 'U',
                                      minimumValue: '0'
                                }"
                                :class="['form-control text-right caixa-banda', {
                                                      'is-valid' : animal.BANDA2 && animal.BANDA2 > 0.00,
                                                      'is-invalid' : !animal.BANDA2 || animal.BANDA2 <= 0.00
                                                    }]">
                        </vue-autonumeric>
                        <b-input-group-append>
                          <b-input-group-append>  
                            <b-button :disabled="modalAnimal.pesou2 == false" variant="danger" @click="onRemovePeso()">
                              Remover Peso
                            </b-button>
                          
                        </b-input-group-append>
                        
                      </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <!--/.col-->
                    <b-col sm="7">             
                      <b-input-group  prepend="Peso Total" class="mt-3 font-maquina">
                        <vue-autonumeric  v-model="animal.PESO_TOTAL" 
                                :readonly="true"
                                :options="{
                                  
                                      digitGroupSeparator: '.',
                                      decimalCharacter: ',',
                                      decimalCharacterAlternative: '.',
                                      roundingMethod: 'U',
                                      minimumValue: '0'
                                }"
                                class="form-control text-right font-maquina no-background"  >
                        </vue-autonumeric>
                    </b-input-group>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-input-group  prepend="Qualidade" class="mt-3 font-maquina">
                      <b-form-select  
                                        v-model="animal.ABATE_TIPO_QUALIDADE_ID" 
                                        :options="optionsQualidade"
                                        :readonly="true"
                                        :state="animal.ABATE_TIPO_QUALIDADE_ID != null"
                                        :class="!animal.ABATE_TIPO_QUALIDADE_ID" 
                                        ref="comboSexo">
                          <template slot="first">
                            <option :value="null" >Não Informado</option>
                          </template>
                        </b-form-select>
                    </b-input-group>
                  </b-col>
                </b-row>
            </b-card>

            <template #modal-footer="{ cancel }">
              <b-button variant="success" @click="onPostAnimal()">
                Gravar
              </b-button>
              <b-button    variant="danger" @click="onFecharModalAnimal()">
                Fechar
              </b-button>
            </template>
          </b-modal>
    </div>
  </div>
  
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import CentroEstoquePesquisa from '../../pesquisa/CentroEstoquePesquisa.vue'
import CustoOperacionalPesquisa from '../../pesquisa/CustoOperacionalPesquisa.vue'
import AnimalPesquisa from '../../pesquisa/AnimalPesquisa.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import axios from 'axios'
import vueAxios from 'vue-axios'
import LoginVue from '../../pages/Login.vue'

export default {
  components: {
    VueButtonSpinner,
    FuncionarioPesquisa,
    ClientePesquisa,
    VueAutonumeric,
    CentroEstoquePesquisa,
    CustoOperacionalPesquisa,
    AnimalPesquisa,
    axios,
    vueAxios
  },
  data () {
    return {
      desabilitado: true,
      balanca: {
        ativa: false

      },
      registro: {
            ID                        : null,
            BALANCEIRO_ID             : null,
            COMPRADOR_ID              : null,
            CLIENTE_ID                : null,
            LOTE                      : null,
            DT_LOTE                   : null,
            DT_LANCAMENTO             : null,
            USUARIO                   : null,
            DT_ALTERACAO              : null,
            USUARIO_ALTERACAO         : null,
            VL_EMBARQUE               : null,
            OBS                       : null,
            HORA_ENT                  : null,
            STATUS                    : null,
            CIDADE                    : null,
            CENTRO_ESTOQUE_ID         : null,
            MARCHANT_ID               : null,
            FAZENDA_ID                : null,
            VACA                      : null,
            NOVILHA                   : null,
            BOI                       : null,
            TOURO                     : null,
            BOI_INTEIRO               : null,
            BOI_CAPAO                 : null,
            BUFALO_MACHO              : null,
            BUFALO_FEMEA              : null,
            CUSTO_OPERACIONAL_ID      : null,
            HORA_SAI                  : null,
            OP_FECHADO_EXPEDICAO      : null,
            GTA                       : null,
            DATA_GTA                  : null,
            MINUTA                    : null,
            CENTRO_ESTOQUE_ORIGEM_ID  : null,
            COMPRA_GADO_ID            : null,
            VL_CUSTO_VACA             : null,
            VL_CUSTO_NOVILHA          : null,
            VL_CUSTO_TOURO            : null,
            VL_CUSTO_BUFALO_MACHO     : null,
            VL_CUSTO_BUFALO_FEMEA     : null,
            VL_CUSTO_BOI_INTEIRO      : null,
            VL_SERVICO_CABECA         : null,
            VL_CUSTO_OPERACIONAL      : 0.00,
            VL_CUSTO_BOI              : null,
            DT_VENCIMENTO_ARECEBER    : null,
            DT_VENCIMENTO_APAGAR      : null,
            OP_CREDOR                 : null,
            OP_DEVEDOR                : null,
            VL_UNT_RESERVA            : null,
            VL_TOTAL_RESERVA          : null,
            VL_TOTAL_SERVICO          : null,
            CENTRO_CUSTO_APAGAR_ID    : null,
            CENTRO_CUSTO_ARECEBER_ID  : null,
            HISTORICO_ARECEBER_ID     : null,
            HISTORICO_APAGAR_ID       : null,
            NR_CABECAS                : null,
            NR_CABECAS_RESERVA        : null,
            QUANT_RESERVA             : null,
            VINCULA_COMPRA_GADO       : null,
            OP_TIPO_SERVICO           : null,
            OP_FECHADO_DIARIO         : null,
            OBS_PLANO_EXPEDICAO       : null,
            DT_PREVISAO_EXPEDICAO     : null,
      },
      animal: {
            INDICE                    : null,
            BANDA1                    : 0.0,
            BANDA2                    : 0.0,
            PESO_TOTAL                : 0.0,
            CONDENADO                 : null,
            MOTIVO_CONDENACAO         : null,
            TARA                      : null,
            OP_RESERVADO              : null,
            ETIQUETA_1                : null,
            ETIQUETA_2                : null,
            ABATE_TIPO_QUALIDADE_ID   : null,
            OP_BALANCA                : null
      },
      modalAnimal: {
        pesoBruto : 0.00,
        tara: 0.00,
        pesoDisplay: 0.00,
        pesou1: false,
        pesou2: false,

      },
      tipoServico: [
        {value: '1', text: '1 - PRÓPRIO'},
        {value: '2', text: '2 - SERVIÇO'}
      ],
      parametros : [],
      animaisDoLote: {
        fields: [],
        items: []
      },
      botoes: {
        boi : false,
        boiInteiro: false,
        vaca: false,
        novilha: false,
        capao: false,
        bufaloMacho: false,
        bufaloFemea: false
      },
      rodape: {
        edAnimais: 0,
        edAbatidos: 0,
        edRestante: 0,
        edBandasPesadas: 0,
        edQuilosPesados: 0.00
      },
      tabelaAnimais: {
        fields: [
          {
            key: "INDICE",
            label: 'Etiqueta',
            class:'text-right my-left-border my-left-right my-left-bottom',
          },
          {
            key: "SIGLA",
            label: 'Qualidade',
            class:'text-right my-left-border my-left-right my-left-bottom',
          },
          {
            key: "DESCRICAO",
            label: 'Animal',
            class:'my-left-border my-left-right my-left-bottom',
          },
          {
            key: 'BANDA1', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Banda1 (KG)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'BANDA2', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Banda2 (KG)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'PESO_TOTAL', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Animal (KG)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "CLASSIFICACAO",
            label: 'Classificação',
            class:'my-left-border my-left-right my-left-bottom',
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'text-right my-left-border my-left-right my-left-bottom',
            thStyle: { width: "5%" }
          }
        ],
        items: []
      },
      tabelaAbatidos: {
        fields: [
          {
            key: "DESCRICAO",
            label: 'Animal',
            class:'my-left-border my-left-right my-left-bottom',
          },
          {
            key: 'BANDAS', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Bandas'
          },
          {
            key: 'QUANT', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'MEDIA', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Media (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          }
        ],
        items: []
      },
      tabelaResumoClassificacao: {
        fields: [
          {
            key: "NOME_PRODUTO",
            label: 'Animal',
            class:'my-left-border my-left-right my-left-bottom',
          },
          {
            key: 'DESCRICAO', 
            class:'font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Classificacao'
          },
          {
            key: 'PESO', 
            class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
              value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          }
        ],
        items: []
      },
         
      optionsQualidade: []
      
    }
  },
  methods: {
    desativarBalanca () {
      this.balanca.ativa = false
    },
    ativarBalanca() {
      this.balanca.ativa = true
      this.contandoBalanca()
    },
    contandoBalanca() {
      if (this.balanca.ativa) {
            setTimeout(() => {
              this.contandoBalanca()
              this.getPeso()
            }, 1000)
        }
    },
    getPeso () {
      if (this.modalAnimal.pesou2 == false ) {
        let requisicao = axios.create({
          //baseURL: 'http://192.168.245.128:3019/'
          baseURL: 'http://localhost:3019/'
        })

        
        requisicao.get(`balancaAbate`)
        .then(dados => {
          let v1 = dados.data.Peso
          let v2 = v1.replace(',','.')
          let v3 = parseFloat(v2)

          this.modalAnimal.pesoDisplay = v3
          this.modalAnimal.pesoBruto = v3
        })
        .catch(err => {
          this.balanca.ativa == false
          this.toastCount++
          this.$root.$bvToast.toast(`Balança não Conectada: ${err.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        })

       } else {
        this.modalAnimal.pesoDisplay = 0.00
        this.modalAnimal.pesoBruto = 0.00
      }
    },
    onSelecionaPeso() {

      if (this.modalAnimal.pesoDisplay > 0.00) {
        if (this.animal.BANDA1 <= 0.00) {
          this.animal.BANDA1 = this.modalAnimal.pesoBruto
          this.modalAnimal.pesou1 = true
          this.modalAnimal.pesoDisplay = 0.00
          
        } else {
          this.animal.BANDA2 = this.modalAnimal.pesoBruto
          this.modalAnimal.pesou2 = true
          this.modalAnimal.pesoDisplay = 0.00
        }
      }
    },
    onRemovePeso() {
      
      if (this.animal.BANDA1 > 0 && this.animal.BANDA2 > 0) {
        this.animal.BANDA2 = 0.00
        this.modalAnimal.pesou2 = false
        
      } else {
        this.animal.BANDA1 = 0.00
        this.modalAnimal.pesou1 = false
      }
      
    },
    onFecharModalAnimal() {
      this.desativarBalanca()
      this.$refs['modal-animal'].hide()
    },
    isValid() {
      return     this.registro.DT_LOTE 
              && this.registro.HORA_ENT
              && this.registro.CLIENTE_ID
              && this.registro.MARCHANT_ID
              && this.registro.FAZENDA_ID
              && this.registro.BALANCEIRO_ID
              && this.registro.OP_TIPO_SERVICO
    },
    isValidaAnimal() {
      return     this.animal.PRODUTO_ID
              && this.animal.BANDA1
              && this.animal.BANDA2
              && this.animal.PESO_TOTAL
              && this.animal.ABATE_ID
              && this.animal.ABATE_TIPO_QUALIDADE_ID
    },
    atualizarListaQualidade ()  {
      return new Promise(resolve => {
        this.$http.get('api/protected/producao/getTipoQualidadeListagem')
        .then((data) =>{
          if (data) {
            this.optionsQualidade = []
            let i
            for (i = 0; i < data.data.length; i++) {
              this.optionsQualidade.push({value: data.data[i].ID, text: data.data[i].DESCRICAO})
            }
            resolve(true)
          } else {
            resolve(false) 
          }
        })
        .catch(() => {
          this.optionsQualidade = []
          this.$store.commit('controle/setAguardando', false)
          resolve(false)
        })
      })
    },
    async onPausar () {
      this.$store.commit('controle/setAguardando', true)
      this.$http.post(`/api/protected/abate/pausar/${this.registro.ID}`)
      .then(() =>{
        this.iniciarAlteracao(this.registro.ID)
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
      await this.atualizarRodape()
      await this.habilitarBotoes()
      
    },
    onContinuar () {
      this.$store.commit('controle/setAguardando', true)
      this.$http.post(`/api/protected/abate/continuar/${this.registro.ID}`)
      .then(() =>{
        this.iniciarAlteracao(this.registro.ID)
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onVoltarPrincipal() {
      this.$store.commit('controle/setAguardando', true)
      let pacote = {
        abateId: this.registro.ID,
        login: window.localStorage.getItem('login')
      }
      this.$http.post('/api/protected/abate/sairDaColeta', pacote)
      .then(() => {
        this.$store
        .dispatch('ordemAbate/GERAR_LISTA')
        .then(() => {
          this.$store.commit('controle/setAguardando', false)
          this.$router.push(`/producao/ordemabate/listagem`)
          return
        }).catch((error) => {
          if (error) {
            this.$root.$bvToast.toast(`Não foi possível atualizar a Lista de Ordens de Abate \n Tente Filtrar Manualmente!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
          this.$router.push(`/producao/ordemabate/listagem`)
          }
        })
      })
      .catch((erro) => {
        if (erro.response && erro.response.status == 400) {
              this.toastCount++
              this.$root.$bvToast.toast(erro.response.data, {
                title: 'Falha',
                autoHideDelay: 4000,
                variant: 'warning',
                appendToast: true
              })
            } else {
              this.toastCount++
              this.$root.$bvToast.toast(erro, {
                title: 'Falha',
                autoHideDelay: 4000,
                variant: 'warning',
                appendToast: true
              })
            }
      })
    },
    async onAbrirModalAnimal(botao) {
      if (await this.atualizarListaQualidade() == false ) {
        this.toastCount++
        this.$root.$bvToast.toast(`Não foi possivel carregar a lista de qualidades do produto`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
        return  
      }
      
      this.limparObjeto(this.animal)
      if (botao == 'vaca') {
       this.animal.PRODUTO_ID = this.parametros[0].VACA_ID 
      } else if (botao == 'boi') { 
       this.animal.PRODUTO_ID = this.parametros[0].BOI_ID
      } else if (botao == 'capao') { 
       this.animal.PRODUTO_ID = this.parametros[0].BOI_CAPAO_ID
      } else if (botao == 'novilha') { 
       this.animal.PRODUTO_ID = this.parametros[0].NOVILHO_ID 
      } else if (botao == 'touro') { 
       this.animal.PRODUTO_ID = this.parametros[0].TOURO_ID 
      } else if (botao == 'bufaloMacho') { 
       this.animal.PRODUTO_ID = this.parametros[0].BUFALO_MACHO_ID
      } else if (botao == 'bufaloFemea') { 
       this.animal.PRODUTO_ID = this.parametros[0].BUFALO_FEMEA_ID
      } else {
        this.$root.$bvToast.toast(`O Animal para esse botão não foi parametrizado no sistema!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }

      this.animal.BANDA1 = 0.00
      this.animal.BANDA2 = 0.00
      this.animal.PESO_TOTAL = 0.00
      this.modalAnimal.pesou1 = false
      this.modalAnimal.pesou2 = false

      this.ativarBalanca()

      this.$refs['modal-animal'].show()
    },
    focusModalAnimal (){
      this.$refs.edBANDA1.$refs.autoNumericElement.focus()
    },
    async onPostAnimal () {
      this.animal.ABATE_ID = this.registro.ID
      this.animal.CENTRO_ESTOQUE_ID = this.registro.CENTRO_ESTOQUE_ORIGEM_ID
      this.animal.CENTRO_ESTOQUE_BANDA1_ID = this.registro.CENTRO_ESTOQUE_ORIGEM_ID
      this.animal.CENTRO_ESTOQUE_BANDA2_ID = this.registro.CENTRO_ESTOQUE_ORIGEM_ID
      this.animal.TARA = 0.00
      this.animal.CONDENADO = '0'
      this.animal.OP_BALANCA = 'M'

      if (!this.isValidaAnimal()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      } else {
        this.$store.commit('controle/setAguardando', true)   
        let gravouAnimal = await this.gravarNovoAnimal()
        if (gravouAnimal == true) {
          this.desativarBalanca()
          let atualizouListaAnimal = await this.atualizarListaAnimal()
          if (atualizouListaAnimal) {
            await this.atualizarRodape()
            await this.habilitarBotoes()
            await this.atualizarListaPesados()
            await this.atualizarListaClassificacao()

            this.$refs['modal-animal'].hide()
            if (await this.getStatusOrdem() == true) {
              
              this.$refs['modal-animal'].hide()
            } else {
              this.$store.commit('controle/setAguardando', false)   
              return
            }
            this.$store.commit('controle/setAguardando', false)
            
          } else {
            this.$store.commit('controle/setAguardando', false)   
          }
        } else {
          this.$store.commit('controle/setAguardando', false)   
        }
      } 
    },
    gravarNovoAnimal () {
      return new Promise(resolve => {
        this.$http.post(`/api/protected/abate/item/peso/postWeb`, this.animal)
        .then(() =>{
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaAnimal () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/abate/item/getViewPesagemByAbateId/${this.registro.ID}?ordem=W`)
        .then(result =>{
          this.tabelaAnimais.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarParametros () {
      this.parametros = []
      return new Promise(resolve => {
        this.$http.get(`/api/protected/parametro/getanimais`)
        .then(result =>{
          this.parametros = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaItem () {
      this.animaisDoLote.items = []
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getAnimalListagemAbateByAbateId/${this.registro.ID}`)
        .then(result =>{
          this.animaisDoLote.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaPesados () {
      this.tabelaAbatidos.items = []
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getViewDetalheByAbateId/${this.registro.ID}`)
        .then(result =>{
          this.tabelaAbatidos.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaClassificacao () {
      this.tabelaResumoClassificacao.items = []
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getRelViewResumosByAbateId/${this.registro.ID}`)
        .then(result =>{
          this.tabelaResumoClassificacao.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    async onDeleteAnimal (item) {
      this.$store.commit('controle/setAguardando', true)   
      if (await this.excluirAnimal(item) == true) {
        if (await this.atualizarListaAnimal() == true) {
          if (await this.getStatusOrdem() == true) {
            await this.habilitarBotoes()
            await this.atualizarRodape()
            await this.atualizarListaPesados()
            await this.atualizarListaClassificacao()
            this.$refs['modal-animal'].hide()
          } else {
            this.$store.commit('controle/setAguardando', false)   
            return
          }
        } else {
          this.$store.commit('controle/setAguardando', false)   
          return
        }
      } else {
        this.$store.commit('controle/setAguardando', false)   
        return
      }

      this.$store.commit('controle/setAguardando', false)

      this.toastCount++
      this.$root.$bvToast.toast(`Animal removido da lista de Ordem de Abate`, {
        title: 'Atenção',
        autoHideDelay: 3000,
        variant: 'success',
        appendToast: true
      })
    },
    getStatusOrdem () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getById/${this.registro.ID}`)
        .then((result) =>{
          this.registro.STATUS = result.data[0].STATUS
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    excluirAnimal (item) {
      return new Promise(resolve => {
        this.$http.post(`/api/protected/abate/item/peso/deleteWeb/${item.ID}/${this.registro.ID}`)
        .then(() =>{
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarRodape () {
     return new Promise(resolve  => {
      this.rodape.edAnimais = 0
      this.rodape.edAnimais = this.registro.VACA +
                              this.registro.NOVILHA +
                              this.registro.BOI+
                              this.registro.TOURO +
                              this.registro.BOI_INTEIRO  +
                              this.registro.BOI_CAPAO  +
                              this.registro.BUFALO_MACHO +
                              this.registro.BUFALO_FEMEA


      this.rodape.edAbatidos = this.tabelaAnimais.items.length ? this.tabelaAnimais.items.length : 0
      this.rodape.edRestante =  (this.rodape.edAnimais ? this.rodape.edAnimais : 0) - (this.rodape.edAbatidos ? this.rodape.edAbatidos : 0)
      this.rodape.edBandasPesadas = 0
      this.rodape.edQuilosPesados = 0.00
      for (let i = 0; i < this.tabelaAnimais.items.length; i++) {
        const e = this.tabelaAnimais.items[i]
        this.rodape.edBandasPesadas += 2
        this.rodape.edQuilosPesados += e.PESO_TOTAL
      }
      resolve(true)
    }) 

  },
    onGravarNovo () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      this.$store.commit('controle/setAguardando', true)    

      if (this.tabelaAnimais.items && this.tabelaAnimais.items.length > 0 ) {
        this.registro.STATUS = '2' // Planejamento Iniciado
      } else {
        this.registro.STATUS = '1' //lancamentos principais
      }
      
      this.$http.post(`/api/protected/producao/post`, this.registro)
      .then(() => {
        this.$router.go(-1)
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++
        this.$root.$bvToast.toast(`Ordem de Abate Gravada com Sucesso!!!`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onGravarEditar () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/producao/edit`, this.registro)
      .then(() => {
        this.$router.go(-1)
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++
        this.$root.$bvToast.toast(`ALTERAÇÕES gravadas com Sucesso!!!`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onIniciarCadastramento () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/producao/post`, this.registro)
        .then((result) => {
          this.registro.ID = result.data.id


          this.$store.commit('controle/setAguardando', false)
          this.toastCount++
          this.$root.$bvToast.toast(`Dadas inicias cadastrados!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
        })
    },
    async getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    async iniciarAlteracao(id) {
      this.desabilitado = false
      
      let reg = await this.getRegistroById(id)

      if (reg == null) {
        
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Falha ao localizar a Ordem de Abate!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
      
      reg.data[0].DT_LOTE = moment(new Date(reg.data[0].DT_LOTE)).format('YYYY-MM-DD')
      reg.data[0].DT_LANCAMENTO = moment(new Date(reg.data[0].DT_LANCAMENTO)).format('YYYY-MM-DD')
      reg.data[0].DT_ALTERACAO = moment(new Date(reg.data[0].DT_ALTERACAO)).format('YYYY-MM-DD')
      reg.data[0].HORA_ENT = moment(new Date(reg.data[0].HORA_ENT)).format('HH:mm:ss')
      reg.data[0].HORA_SAI = moment(new Date(reg.data[0].HORA_SAI)).format('HH:mm:ss')
      
      this.registro = reg.data[0]
      
      this.tabelaAnimais.items = []

      if (await this.atualizarListaAnimal() == false) {
        this.toastCount++
        this.$root.$bvToast.toast(`Os Animais da Ordem de Abate não foram encontrados no Banco de Dados`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
      
      if ( await this.atualizarParametros() == false) {
        this.toastCount++
        this.$root.$bvToast.toast(`Os parametros do sistema não foram configurados para a Coleta`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }

      if (await this.atualizarListaItem() == false) {
        this.toastCount++
        this.$root.$bvToast.toast(`Os Animais da Ordem de Abate não foram encontrados no Banco de Dados`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
        
      await this.habilitarBotoes()
      await this.atualizarRodape()
      await this.atualizarListaPesados()
      await this.atualizarListaClassificacao()
      this.$store.commit('controle/setAguardando', false)
      return
      
    },
    habilitarBotoes() {
      return new Promise( resolve => {
        this.botoes.boi = false
        this.botoes.boiInteiro = false
        this.botoes.vaca = false
        this.botoes.novilha = false
        this.botoes.capao = false
        this.botoes.bufaloMacho = false
        this.botoes.bufaloFemea = false
        this.botoes.touro = false

        let qtBoi = 0
        let qtBoiInteiro = 0
        let qtVaca = 0
        let qtNovilha = 0
        let qtCapao = 0
        let qtBufaloMacho = 0
        let qtBufaloFemea = 0
        let qtTouro = 0

        //Habilita se o animal ainda tive saldo
        for (let i = 0; i < this.tabelaAnimais.items.length; i++) {
          const e =this.tabelaAnimais.items[i]
          
          if (e.PRODUTO_ID == this.parametros[0].VACA_ID) { qtVaca ++ }
          if (e.PRODUTO_ID == this.parametros[0].BOI_ID) { qtBoi ++ }
          if (e.PRODUTO_ID == this.parametros[0].BOI_CAPAO_ID) { qtCapao ++ }
          if (e.PRODUTO_ID == this.parametros[0].NOVILHO_ID) { qtNovilha ++ }
          if (e.PRODUTO_ID == this.parametros[0].TOURO_ID) { qtTouro ++ }
          if (e.PRODUTO_ID == this.parametros[0].BUFALO_MACHO_ID) { qtBufaloMacho ++ }
          if (e.PRODUTO_ID == this.parametros[0].BUFALO_FEMEA_ID) { qrBufaloFemea ++ }
        }
        
        this.botoes.vaca = this.registro.VACA > qtVaca 
        this.botoes.novilha = this.registro.NOVILHA > qtNovilha
        this.botoes.boi = this.registro.BOI > qtBoi
        this.botoes.touro = this.registro.TOURO > qtTouro
        this.botoes.boiInteiro = this.registro.BOI_INTEIRO  > qtBoiInteiro
        this.botoes.capao = this.registro.BOI_CAPAO  > qtCapao
        this.botoes.bufaloMacho = this.registro.BUFALO_MACHO > qtBufaloMacho
        this.botoes.bufaloMacho = this.registro.BUFALO_FEMEA > qtBufaloFemea

        /*
        //Habilita se o animal estiver na Ordem de Abate
        for (let i = 0; i < this.animaisDoLote.items.length; i++) {
          const e =this.animaisDoLote.items[i]
          
          if (e.PRODUTO_ID == this.parametros[0].VACA_ID) { this.botoes.vaca = true }
          if (e.PRODUTO_ID == this.parametros[0].BOI_ID) { this.botoes.boi = true }
          if (e.PRODUTO_ID == this.parametros[0].BOI_CAPAO_ID) { this.botoes.capao = true }
          if (e.PRODUTO_ID == this.parametros[0].NOVILHO_ID) { this.botoes.novilha = true }
          if (e.PRODUTO_ID == this.parametros[0].TOURO_ID) { this.botoes.touro = true }
          if (e.PRODUTO_ID == this.parametros[0].BUFALO_MACHO_ID) { this.botoes.bufaloMacho = true }
          if (e.PRODUTO_ID == this.parametros[0].BUFALO_FEMEA_ID) { this.botoes.bufaloFemea = true }
        }

        */
        resolve(true)
      })


    },
    compararObjeto (a, b) {
      if ((a == []) && (b == [])) {
        return true
      }
      let prop1
      try {
        prop1 = Object.getOwnPropertyNames(a)
      } catch (ex) {
        try {
          Object.getOwnPropertyNames(b)
        } catch (exx) {
          return true
        }
        return false
      }
       
      for (var i = 0; i < prop1.length; i++) {
        var prop = prop1[i]
        if ((prop.indexOf("__ob__") == -1) && (a[prop] != b[prop])) {
          return false
        }
      }
      return true
    },
    limparObjeto (a) {
      let prop1 = Object.getOwnPropertyNames(a)
      for(var i = 0; i < prop1.length; i++) {
        var prop = prop1[i]
        if ((prop.indexOf("__ob__") == -1) ) {
          a[prop] = null
        }
      }
    },
    exibirBotaoExcluirItem: function (item) {
      let posicao = 0
      for (let i = 0; i < this.tabelaAnimais.items.length; i++) {
        const e = this.tabelaAnimais.items[i];
        posicao ++
        if (e.ID == item.ID) {
          break;
        }
      }

      if (posicao == 1  ) {
        if (this.registro.STATUS == '7') { //PAUSA
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
    
  },
  created () {

    let id = this.$route.params.id
    //ALTERACAO
    if ( id ) {
      this.iniciarAlteracao(id)
      
    } 
    //NOVO REGISTRO
    else {
      this.$route.go(-1)
    }
  },
  computed: {
    traduzStatus : function () {
      if (this.registro.STATUS == null) return ''
      switch (this.registro.STATUS) {
        case  '0' : return 'CANCELADA'
        case  '1' : return 'LANCAMENTO PRINCIPAIS' 
        case  '2' : return 'PLANEJAMENTO INICIADO' 
        case  '3' : return 'PRONTO PARA COLETA' 
        case  '4' : return 'COLETA INICIADA' 
        case  '5' : return 'COLETA ENCERRADA'     
        case  '6' : return 'FECHADO' 
        case  '7' : return 'PAUSA' 
        default:
          break;
      }
    }
  },
  watch: {
    'animal.BANDA1': function() {
        this.animal.PESO_TOTAL = (this.animal.BANDA1 && this.animal.BANDA1 > 0 ? this.animal.BANDA1 : 0.00)  + 
        (this.animal.BANDA2 && this.animal.BANDA2 > 0 ? this.animal.BANDA2 : 0.00)
    },
    'animal.BANDA2': function() {
      this.animal.PESO_TOTAL = (this.animal.BANDA2 && this.animal.BANDA2 > 0 ? this.animal.BANDA2 : 0.00)  + 
        (this.animal.BANDA1 && this.animal.BANDA1 > 0 ? this.animal.BANDA1 : 0.00)
    }
  }
}
</script>


<style>
  .card-header .card-alinha {
    position: absolute;
    top: 0;
    right: 0;
    
  }

 .card-header .card-alinha button {
    display: block;
    float: left;
    padding: 0.75rem 1rem;
    margin: 0 !important;
    
    text-align: center;
    
    border: 0;
    border-left: 1px solid #a4b7c1;
    -webkit-box-shadow: 0;
    box-shadow: 0;
 }

 .b-table .my-left-border {
  border-left: 1px solid #a4b7c1;
  }
  .b-table .my-left-right {
    border-right: 1px solid #a4b7c1;
  }
  .b-table .my-left-bottom {
    border-bottom: 1px solid #a4b7c1;
  }

  .font-maquina { 
    font-family: Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace; 
    
  }
  .caixa-display {
    font-family: Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace; 
    font-size: 1.999rem !important;
    background-color: #f0f3f5 !important;
    font-weight: 800 !important;
  }
  .caixa-tara {
    font-family: Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace; 
    font-size: 1.999rem !important;
    background-color: #f0f3f5 !important;
    font-weight: 800 !important;
  }
  .caixa-bruto {
    font-family: Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace; 
    font-size: 1.999rem !important;
    background-color: #f0f3f5 !important;
    font-weight: 800 !important;
    color: #4dbd78;
  }

  .caixa-banda {
    font-family: Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace; 
    background-color: #ffff !important;
    font-weight: 800 !important;
  }

  .caixa-cabecalho {
    display: block;
    margin-bottom: 0;
    background-color: #f0f3f5;
    border: 1px solid #c2cfd6;
    text-align: center;
    font-weight: 800 !important;
    font-family: Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace; 
  }

</style>


// WEBPACK FOOTER //
// src/views/producao/ordemabate/OrdemAbateColeta.vue